/**
 * Two-letter initials for an avatar-sized placeholder — the first letter of
 * up to the first two space-separated words of a display name, upper-cased.
 *
 * Shared by `UserAvatar` and `PhotoBoard`, which each show the same fallback
 * face for "no photo yet" — one as a small circular avatar, the other as the
 * empty frame in the current/proposed comparison.
 */
export function getInitials(name: string): string {
  return name
    .split(' ')
    .map((p) => p[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}
